import React from 'react';
import Component from '../../components/Component';
import Datagrid from '../../components/Datagrid';
import Renderers from '../../helpers/Renderers';
import DbInfo from '../../dbinfo';
import ApiClient from '../../helpers/ApiClient';
import c from '../../constants';
import config from '../../config';
import {FormManager} from 'reactis-forms';
import {FilterInput, Select, SearchInput} from 'reactis-inputs';
import {FilterResetButton, FilterField} from 'reactis-datagrid';
import {Button, ButtonToolbar} from 'react-bootstrap';
import {AlertWindow, ConfirmWindow} from 'reactis-modal';
import EventEmitter from '../../EventEmitter';
import DateRange from '../../components/Form/DateRange';
import DocumentTitle from 'react-document-title';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import moment from 'moment';
import NavBar from '../../components/NavBar';
import store from 'store2';

export default class List extends Component {

	static contextTypes = {
		location: React.PropTypes.object,
		store: React.PropTypes.object,
		flashMessage: React.PropTypes.func
	};

	constructor(props, context) {
		super(props);

		this.columnModel = [
			/*{
				name: 'id',
				title: 'Název',
				field: 'id'
			},*/
			{
				name: 'os',
				title: 'Operační systém',
				field: 'device',
				sortable: false,
				renderer: (val) => {
					return <span><img style={{height:25, marginTop:5, marginBottom:5, marginRight: 10}} src={config.assets + 'assets/images/device/os/' + val.os.short_name + '.png'} /> {val.os.name + ' ' + val.os.version}</span>;
				}
			},
			{
				name: 'device',
				title: 'Zařízení',
				field: 'device',
				sortable: false,
				renderer: (val) => {
					return <span><img style={{height:25, marginTop:5,  marginBottom:5, marginRight: 10}} src={config.assets + 'assets/images/device/browsers/' + val.client.short_name + '.png'} /> {val.client.name + ' ' + val.client.version}</span>;
				}
			},
			{
				name: 'country',
				title: 'Lokace',
				field: 'country',
				renderer: (val, row) => {
					return <span><img style={{marginRight: 10}} src={config.assets + 'assets/images/flags/' + row.country.toLowerCase() + '.png'} /> <span className="hidden-xs">{row.city}</span></span>;
				}
			},
			{
				name: 'ip',
				title: 'IP',
				field: 'ip',
				viewport: 'tablet'
			},
			{
				name: 'timestamp',
				title: 'Poslední akce',
				field: 'timestamp',
				viewport: 'tablet',
				renderer: (ts) => {
					const m = moment(ts * 1000);
					return Renderers.DateTime(m);
				}
			},
			{
				name: 'action',
				title: 'Akce',
				width: 50,
				align:'center',
				sortable: false,
				renderer: (val, row) => {
					return <span onClick={() => this.handleDelete(row)} className="btn btn-sm btn-danger">Odhlásit</span>;
				}
			},
		];

		const filterSchema = {
			fulltext: { class: SearchInput },
			edit: {
				class: FilterResetButton,
				visible: () => this.filter.isChanged(),
				onClick: () => this.filter.reset()
			}
		};
		this.filter = new FormManager(filterSchema);
		const sessionState = store.session.get('dg-session');
		// default
		let filter = {};
		// session
		if (sessionState && sessionState.filter) {
			filter = sessionState.filter;
		}
		this.defaultFilter = filter;
		this.defaultSort = sessionState && sessionState.sort ? sessionState.sort : {column: 'timestamp', 'direction': 'desc'};

	}

	componentDidMount() {
		this.changeListener = () => {
			this.refs.datagrid.getWrappedInstance().refresh();
		};
		EventEmitter.on('session.change', this.changeListener);
	}

	componentWillUnmount() {
		EventEmitter.removeListener('session.change', this.changeListener);
	}

	handleDelete(row) {
		const confirm = new ConfirmWindow('Potvrzení', 'Opravdu si přejete se ohlásit z tohoto zařízení?');
		confirm.show(this.context.store.dispatch, () => {
			const api = new ApiClient();
			api.call('session.delete', {id: row.id}, {progress: true}).then((result) => {
				if (!result.error) {
					EventEmitter.emit('session.change');
				}
			});
		});
	}

	render() {
		return (
		<div className="tdidocument">
			<DocumentTitle title="Moje přihlášené zařízení" />
			<NavBar title="Moje přihlášené zařízení" />
			<div className="panel" style={{paddingBottom: 0, minHeight: 680}}>
				<div style={{padding:'0px 20px 10px 20px'}}>
					<Datagrid
						ref="datagrid"
						id="session"
						api="session.getList"
						buttons={<h3>Moje přihlášené zařízení</h3>}
						filters={['fulltext']}
						filter={this.filter}
						saveState={true}
						columnModel={this.columnModel}
						defaultFilter={this.defaultFilter}
						defaultSort={this.defaultSort}
					/>
				</div>
			</div>
		</div>

		)
	}
}


// WEBPACK FOOTER //
// ./src/containers/Session/List.js